export default __webpack_public_path__ + "static/preschool4-bebd9ac9326acf62ba6f51e4b02ab6bf.jpg";